<template>
    <div v-if="loading" class="main-spinner-panel">
        <div v-if="!slider" class="spacer"></div>
        <div class="spinner-border text-primary mt-2" role="status"></div>
        <div v-show="slider" class="spinner-images">
            <vcarousel :data="list" class="lg" :controls="false" :indicators="false" :autoplay="true" :interval="4000" :pauseOnEnter="false"></vcarousel>
        </div>
    </div>
</template>

<script>
import IMAGE_1 from '../../assets/images/project/loader/banner-loading.jpg'
import IMAGE_2 from '../../assets/images/project/loader/banner-loading-2.jpg'
import IMAGE_3 from '../../assets/images/project/loader/banner-loading-3.jpg'
import IMAGE_4 from '../../assets/images/project/loader/banner-loading-4.jpg'
import MobileDetector from './MobileDetector'
export default {
  name: 'MainSpinnerPanel',
  mixins: [MobileDetector],
  computed: {
    loading () {
      return this.$store.getters.isLoading
    },
    slider () {
      return this.$store.getters.isSlider
    },
    images () {
      return [IMAGE_1, IMAGE_2, IMAGE_3, IMAGE_4]
    },
    list () {
      return this.images.map(image => {
        return this.isMobile ? `<img src="${image}" width="100%" height="${this.windowWidth - this.windowWidth * 0.2}"/></img>` : `<div class="slide image-contain" style="width: 500px; height: 400px" :style="\`background-image: url(${image})\`"></div>`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/common/MainSpinnerPanel.vue